import React from 'react';
import { Message } from 'rebass';

import config from 'frontend/config';

const SimcWarning = () => (
  <Message theme="warning" style={{ display: '' }} p={1} mt={3}>
    Results are only as good as the SimulationCraft model for your
    spec! Check other trusted sources to figure out if your spec is
    well supported and/or {' '}
    <a
      href="https://github.com/simulationcraft/simc#how-can-i-contribute"
      style={{
        color: config.colors.white,
        textDecoration: 'underline',
      }}
    >
      dive into SimulationCraft
    </a>
    {' '}
    itself and get involved!
  </Message>
);

export default SimcWarning;
